import React, {useEffect, useState} from 'react'

import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision, actionsLogin} from '../../actions/action-creators'
import {LoaderRedux} from '../../components/LoaderRedux'
import DynamicDocContent from './Components/GenerarDocumento/DynamicDocContent'
import {Link, useHistory} from 'react-router-dom'
import ModalsGeneracionFactura from '../EmitirFactura/Components/GeneracionFactura/Modals/ModalsGeneracionFactura'
import { facturacionClearAll } from '../../actions/facturacion/facturacionEmision.actions'

const GeneracionDocumento = () => {
  const loader = useSelector((state: State) => state.general.loader)
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const sucursales = useSelector((state: State) => state.facturacion.catalogoSucursal)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionFacturacionEmision, dispatch)
  const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
  const [loader2, setLoader2] = useState(false)
  const history = useHistory()

  useEffect(() => {
    getSucursales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sucursales])

  const getSucursales = async () => {
    if (sucursales.length === 0) {
      setLoader2(true)
      suscripcionGetFacturasDisponibles()
      await actions.facturacionPostSucursales()
      setLoader2(false)
    }
  }

  const handleGoBack = () => {
    if (activeDoc.idDoc === '05') {
      history.push('/history-invoice')
    } else {
      history.push('/otros-documentos')
    }
  }

  return (
    <>
      {!loader && loader2 && <LoaderRedux />}
      <ModalsGeneracionFactura />
      <div className='header-link'>
        <button onClick={handleGoBack} className='back-button w-inline-block'></button>
        {/* <Link to={""} className='back-button w-inline-block'></Link> */}
        <h3 className='h3-titles xl'>{activeDoc?.title}</h3>
      </div>
      <div className='separador'></div>
      <div
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <DynamicDocContent />
      </div>
    </>
  )
}

export default GeneracionDocumento
